import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./HomepageConnect.scss";
import { ConnectComponent_Plain } from "../../types/components/homepage/ConnectComponent.ts";
import { getStrapiMedia } from "../../utils/utils.tsx";
import { useTranslation } from "react-i18next";

const HomepageConnect = ({ data }: { data: ConnectComponent_Plain }) => {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const names = data.office.map((item, i: number) => (
    <div
      className={`connect-text__item ${activeIndex === i ? "active" : activeIndex !== null ? "not-active" : ""}`}
      key={i}
    >
      {item.country}
    </div>
  ));

  const handleConnectItemClick = (email: string) => {
    const selectItem = document.querySelector(
      `.message-to__select-dropdown li[data-email="${email}"]`,
    );
    if (selectItem) {
      (selectItem as HTMLLIElement).click();
    } else {
      console.warn(`Item with email ${email} not found in FooterForm select`);
    }
  };

  const blocks = data.office.map((item, i: number) => (
    <SwiperSlide
      className="connect-list__item"
      key={i}
      data-email={item.email}
      onMouseEnter={() => setActiveIndex(i)}
      onMouseLeave={() => setActiveIndex(null)}
      onClick={() => handleConnectItemClick(item.email)}
    >
      <div className="connect-list__top">
        <h3
          dangerouslySetInnerHTML={{
            __html: item.city + ", " + item.country,
          }}
        ></h3>
        {item.image ? (
          <div className="connect-list__img">
            <img
              src={getStrapiMedia(item.image.url)}
              width="50"
              height="50"
              alt={item.country}
              loading="lazy"
              decoding="async"
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="connect-list__inf">
        <div className="connect-list__inf-line">
          <span>{t("Address")}:</span>
          <span>{item.address}</span>
        </div>
        <div className="connect-list__inf-line">
          <span>{t("Tel.")}:</span>
          <span>{item.phone}</span>
        </div>
      </div>
      <a href={item.googleMap} className="connect-list__link" target="_blank">
        {t("Show on Google Maps")}{" "}
        <span className="connect-list__link-icon"></span>
      </a>
    </SwiperSlide>
  ));

  const images = data.office.map((item, i: number) => (
    <img
      key={i}
      src={item.image ? getStrapiMedia(item.image.url) : "/img/placeholder.jpg"}
      alt={item.country}
      loading="lazy"
      decoding="async"
      width={item.image?.width || undefined}
      height={item.image?.height || undefined}
      className={`
        ${i === 0 ? "active" : ""}
        ${activeIndex === i ? "active" : activeIndex !== null ? "not-active" : ""}
      `}
    />
  ));

  return (
    <section className="box-connect" id="contacts">
      <div className="connect-img">{images}</div>
      <div className="wrapper">
        <h2>{data.title}</h2>
        <div className="connect-text">
          {data.text}
          {names}
        </div>
        <div className="connect-list">
          <Swiper
            ref={swiperRef}
            modules={[Navigation, Pagination]}
            spaceBetween={16}
            slidesPerView={4}
            breakpoints={{
              0: { slidesPerView: 1.3 },
              768: { slidesPerView: 2.5 },
              1024: { slidesPerView: 4 },
            }}
            navigation
            pagination={{
              clickable: true,
              type: "fraction",
            }}
            className="connect-swiper"
          >
            {blocks}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HomepageConnect;
